import { useContext } from "react";
import { AuthorizationContext, AuthPropType, SetAuthPropType } from "./authorizationContext";

export const useAuthorization = (): [AuthPropType, SetAuthPropType] => {
  const { auth, setAuth } = useContext(AuthorizationContext);
  return [auth, setAuth];
};
